import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { COMPANY_INFO, NAVIGATION_ITEMS } from "../../../data/company";
import { scrollToElement, getCurrentYear } from "../../../utils/helpers";
import "./Footer.css";
import { useLanguage } from "../../../context/LanguageContext";

export const Footer: React.FC = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const handleNavClick = (href: string) => {
    if (href.startsWith('/')) {
      navigate(href);
      return;
    }
    const elementId = href.replace('#', '');
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => scrollToElement(elementId), 0);
    } else {
      scrollToElement(elementId);
    }
  };

  const currentYear = getCurrentYear();

  return (
    <footer className="footer">
      <div className="footer__main">
        <div className="container">
          <div className="footer__content">
            {/* Company Info */}
            <div className="footer__section">
              <div className="footer__logo">
                <img
                  className="footer__logo-image"
                  src={`${process.env.PUBLIC_URL}/logo1.png`}
                  alt="ESF OTOMOTİV"
                  loading="eager"
                />
              </div>

              <p className="footer__description">
                {t('footer.description')}
              </p>

              <div className="footer__social">
                <a
                  href={COMPANY_INFO.social.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a
                  href={COMPANY_INFO.social.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a
                  href={COMPANY_INFO.social.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a
                  href={COMPANY_INFO.social.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer__section">
              <h4 className="footer__section-title">{t('footer.quickLinks')}</h4>
              <ul className="footer__links">
                {NAVIGATION_ITEMS.map((item) => (
                  <li key={item.id}>
                    <button
                      className="footer__link"
                      onClick={() => handleNavClick(item.href)}
                    >
                      {t(`nav.${item.id}`)}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/** Ürün Kategorileri bölümü kaldırıldı **/}

            {/* Contact Info */}
            <div className="footer__section">
              <h4 className="footer__section-title">{t('contact.info.title')}</h4>

              <div className="footer__contact-item">
                <i className="fas fa-map-marker-alt"></i>
                <div>
                  <p>{COMPANY_INFO.contact.address.fullAddress}</p>
                </div>
              </div>

              <div className="footer__contact-item">
                <i className="fas fa-phone"></i>
                <div>
                  {COMPANY_INFO.contact.phone.map((phone, index) => (
                    <p key={index}>
                      <a href={`tel:${phone}`}>{phone}</a>
                    </p>
                  ))}
                </div>
              </div>

              <div className="footer__contact-item">
                <i className="fas fa-envelope"></i>
                <div>
                  {COMPANY_INFO.contact.email.map((email, index) => (
                    <p key={index}>
                      <a href={`mailto:${email}`}>{email}</a>
                    </p>
                  ))}
                </div>
              </div>

              <div className="footer__contact-item">
                <i className="fas fa-clock"></i>
                <div>
                  <p>{t('company.hours.weekdays')}</p>
                  <p>{t('company.hours.saturday')}</p>
                  <p>{t('company.hours.sunday')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer__bottom">
        <div className="container">
          <div className="footer__bottom-content">
            <div className="footer__copyright">
              <p>
                &copy; {currentYear} {COMPANY_INFO.name}. {t('footer.copyright')}
              </p>
            </div>

            <div className="footer__legal">
              <button className="footer__legal-link">
                {t('footer.legal.privacy')}
              </button>
              <button className="footer__legal-link">{t('footer.legal.terms')}</button>
              <button className="footer__legal-link">{t('footer.legal.cookies')}</button>
            </div>
          </div>

          <div className="footer__developer">
            <p>
              <a
                href="https://maezmayazilim.online"
                target="_blank"
                rel="noopener noreferrer"
              >
                Maezma Yazılım Çözümleri
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
